export const companyTeamEn = {
  // START MICHAEL
  CREATE_TEAM: 'Create Team',
  TEAM_NAME: 'Team Name',
  TEAM_DESCRIPTION: 'Team Description',
  TEAMS: 'Teams',
  NO_OF_CLIENTS: 'Nº of clients',
  TEAM_NAME_MUST_BE_MAX_50_DIGITS: 'Team name must be maximum 50 digits',
  TEAM_DESCRIPTION_MUST_BE_MAX_255_DIGITS: 'Team description must be maximum 255 digits',
  TEAM_CREATED_SUCCESSFULLY: 'Team created successfully',
  COMPANIES_ADDED_TO_TEAM_SUCCESSFULLY: 'Companies added to team successfully',
  UPDATE_TEAM: 'Update Team',
  TEAM_UPDATED_SUCCESSFULLY: 'Team updated successfully',
  COMPANIES_OF_TEAM_UPDATED_SUCCESSFULLY: 'Companies of team updated successfully',
  TEAM_DELETED_SUCCESSFULLY: 'Team deleted successfully',
  DELETE_TEAM: 'Delete Team',
  DELETE_TEAM_CONFIRMATION: 'Are you sure you want to delete the selected team(s)?',
  COMPANY_TEAM: 'Company Team',
  ADD_TEAM: 'Add Team',
  REMOVE_TEAM: 'Remove Team',
  CONFIRM_REMOVE_TEAM_FROM_COMPANY: 'Are you sure you want to remove the selected team(s) from the company?',
  TEAMS_REMOVED_FROM_COMPANY_SUCCESSFULLY: 'Teams removed from company successfully',
  COMPANY_ADDED_TO_TEAMS_SUCCESSFULLY: 'Company added to teams successfully',
  TEAMS_ADDED_TO_COMPANY_SUCCESSFULLY: 'Teams added to company successfully',
  ADD_TO_COMPANY: 'Add to Company',
  // END MICHAEL
}

export const companyTeamEs: typeof companyTeamEn = {
  // START MICHAEL
  CREATE_TEAM: 'Crear equipo',
  TEAM_NAME: 'Nombre del equipo',
  TEAM_DESCRIPTION: 'Descripción del equipo',
  TEAMS: 'Equipos',
  NO_OF_CLIENTS: 'Nº de clientes',
  TEAM_NAME_MUST_BE_MAX_50_DIGITS: 'El nombre del equipo debe tener un máximo de 50 dígitos',
  TEAM_DESCRIPTION_MUST_BE_MAX_255_DIGITS: 'La descripción del equipo debe tener un máximo de 255 dígitos',
  TEAM_CREATED_SUCCESSFULLY: 'Equipo creado con éxito',
  COMPANIES_ADDED_TO_TEAM_SUCCESSFULLY: 'Empresas añadidas al equipo con éxito',
  UPDATE_TEAM: 'Actualizar equipo',
  TEAM_UPDATED_SUCCESSFULLY: 'Equipo actualizado con éxito',
  COMPANIES_OF_TEAM_UPDATED_SUCCESSFULLY: 'Empresas del equipo actualizadas con éxito',
  TEAM_DELETED_SUCCESSFULLY: 'Equipo eliminado con éxito',
  DELETE_TEAM: 'Eliminar equipo',
  DELETE_TEAM_CONFIRMATION: '¿Está seguro de que desea eliminar el/los equipo(s) seleccionado(s)?',
  COMPANY_TEAM: 'Equipo de empresa',
  ADD_TEAM: 'Agregar equipo',
  REMOVE_TEAM: 'Eliminar equipo',
  CONFIRM_REMOVE_TEAM_FROM_COMPANY:
    '¿Está seguro de que desea eliminar el/los equipo(s) seleccionado(s) de la empresa?',
  TEAMS_REMOVED_FROM_COMPANY_SUCCESSFULLY: 'Equipos de empresa eliminados de la empresa con éxito',
  COMPANY_ADDED_TO_TEAMS_SUCCESSFULLY: 'Empresa añadida a los equipos con éxito',
  TEAMS_ADDED_TO_COMPANY_SUCCESSFULLY: 'Equipos añadidos a la empresa con éxito',
  ADD_TO_COMPANY: 'Agregar a la empresa',
  // END MICHAEL
}
